module.exports = __webpack_public_path__ + "static/don1-69e64c05f46c783562607cb0dff7fa77.jpg";